import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Lightning = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.187 4h2.785a.75.75 0 0 1 .7 1.019L12.886 9.68a.75.75 0 0 0 .7 1.019H16.5a.75.75 0 0 1 .6 1.2l-5.876 7.835c-.5.666-1.551.143-1.32-.658l1.354-4.708a.75.75 0 0 0-.894-.937l-2.019.48a.75.75 0 0 1-.88-.982l3.016-8.432A.75.75 0 0 1 11.187 4"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Lightning) as SvgIcon;
export { ForwardRef as ReactComponent };
